export default __webpack_public_path__ + "static/media/H0000.a4a65356.png";